import type { ContextValue } from '../../components/SunriseHoldoutExperimentContextProvider';

import type { Props } from './index';

export type ValidatePayPalProps = {
	hasPayPalValidationErrors: boolean;
};

export type ValidatePayPalState = {
	validatePayPal: () => boolean;
	isPayPalButtonEnabled: boolean;
};

export function isValidatePayPalState(props: Props): props is ValidatePayPalProps {
	return !!(props && 'hasPayPalValidationErrors' in props);
}

export function validatePayPalState(
	props: ValidatePayPalProps & {
		userInteracted: ContextValue['userInteracted'];
		setNoSelectionMadeError: ContextValue['setNoSelectionMadeError'];
		variant: ContextValue['variant'];
	},
): ValidatePayPalState {
	const needsUserInteraction = props.variant === 'variant_2' && !props.userInteracted;

	return {
		validatePayPal: () => {
			if (needsUserInteraction) {
				props.setNoSelectionMadeError(true);
				return false;
			}
			if (props.hasPayPalValidationErrors) {
				return false;
			}
			return true;
		},
		isPayPalButtonEnabled: !needsUserInteraction,
	};
}
